import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Phone, MapPin, Calendar } from 'lucide-react'
import ImageSlider from '../components/ImageSlider'
import StatsSection from '../components/sections/StatsSection'
import FeaturedDestinationsSection from '../components/sections/FeaturedDestinationsSection'
import WhyChooseUsSection from '../components/sections/WhyChooseUsSection'
import TestimonialsSection from '../components/sections/TestimonialsSection'
import CTASection from '../components/sections/CTASection'
import { companyStats } from '../data/company'
import { getFeaturedDestinations } from '../data/destinations'
import { testimonials } from '../data/testimonials'

const Home = () => {
  const navigate = useNavigate()
  const featuredDestinations = getFeaturedDestinations()

  return (
    <div className="min-h-screen">
      <ImageSlider 
        autoPlay={true}
        interval={6000}
        showControls={true}
        showIndicators={true}
      />
      
      {/* Contact Info Banner - Only on Home Page */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white/90 backdrop-blur-sm border-b border-gray-100 py-2"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center space-x-8 text-sm text-gray-600">
            <a 
              href="tel:01-5915457"
              className="flex items-center space-x-2 hover:text-blue-600 transition-colors duration-200 cursor-pointer"
            >
              <Phone className="h-4 w-4 text-blue-500" />
              <span>01-5915457</span>
            </a>
            <div className="flex items-center space-x-2">
              <MapPin className="h-4 w-4 text-green-500" />
              <span>24/7 Support Available</span>
            </div>
            <div className="flex items-center space-x-2">
              <Calendar className="h-4 w-4 text-purple-500" />
              <span>Flexible Booking</span>
            </div>
          </div>
        </div>
      </motion.div>
      
      <StatsSection stats={companyStats} />
      
      <FeaturedDestinationsSection destinations={featuredDestinations} />
      
      <WhyChooseUsSection />
      
      <TestimonialsSection testimonials={testimonials} />
      
      <CTASection
        title="Ready to Start Your Adventure?"
        description="Let us help you create memories that will last a lifetime. Contact us today to plan your perfect trip."
        primaryButtonText="Get Started"
        secondaryButtonText="Learn More"
        onPrimaryClick={() => navigate('/contact')}
        onSecondaryClick={() => navigate('/about')}
      />
    </div>
  )
}

export default Home
